import { z } from 'zod';
/**
 * 游标（keyset）分页 —— 流水、审计、库存明细一律使用（Master Spec §49、附录 A-4）。
 * 不使用 offset 分页：大表深翻页会全表扫描，且并发插入会导致行重复/遗漏。
 */
export const DEFAULT_PAGE_SIZE = 50;
export const MAX_PAGE_SIZE = 200;
export const cursorPageQuerySchema = z.object({
    cursor: z.string().min(1).optional(),
    limit: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
});
/** 游标编码为不透明字符串，避免客户端依赖其内部结构 */
export function encodeCursor(value) {
    return Buffer.from(JSON.stringify(value), 'utf8').toString('base64url');
}
export function decodeCursor(cursor) {
    return JSON.parse(Buffer.from(cursor, 'base64url').toString('utf8'));
}
//# sourceMappingURL=pagination.js.map